module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("I am indebted to my primary-school classmates, Lieutenant Colonel David Sinai, Orly Spinzi (Zubali), Dr Miriam Orbach (Frankel) and Yacov Sarfati as well as to Professor Stuart Gabriel at the University of California at Los Angeles, Professor David Zilberman at the University of California at Berkeley, Emeritus Professor and former Rector Jimmy Weinblatt at Ben-Gurion University of the Negev, Emeritus Professor and former Senior Deputy Vice Chancellor at the University of Wollongong John Patterson, and Tirza Kiesler for encouragement and comments. I am also indebted to the members of the WhatsApp groups of my 1964 primary-school class and 1968 high-school class whose explicit and implicit questions and comments I tried to address.")]), _vm._v(" "), _c('p', [_c('strong', [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0